import { render } from "./alert-message.vue?vue&type=template&id=8e67cf70&scoped=true"
import script from "./alert-message.vue?vue&type=script&lang=js"
export * from "./alert-message.vue?vue&type=script&lang=js"

import "./alert-message.vue?vue&type=style&index=0&id=8e67cf70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e67cf70"]])

export default __exports__